import MessageSender from '../sender'
import BaseMessage from '../message'

export default (path, date, grup) => async () => {
  const msg = new BaseMessage()

  msg.setPath(`resume/${path}?key=${path}&date=${date}&grup=${grup}`)

  const response = await new MessageSender().doGet(msg)

  return response
}
